
class ArrowBtn {
  constructor(){
    const toggle = document.querySelector('.arrow-btn');
    if(toggle){
      toggle.addEventListener('click', e => {
        console.log(toggle);
        window.scrollTo({
          top: document.querySelector('.ns-video-wrapper').offsetHeight,
          behavior: 'smooth'
        });
      });
    }
  }
} export default ArrowBtn;
